export default "__VITE_ASSET__Cw83G_qs__"